var filter = function () {
    return function (input) {
        var specialChar = ['(Modified)'];
        var substring = "(Modified)";
        var word = input;
        if (word.length <= 30) {
            return word;
        }
        else {
            if (word.indexOf(substring) !== -1) {
                return word.substr(0, 27) + '... ' + substring;
            }
            else {
                return word.substr(0, 30) + '...';
            }
        }
    };
};
var ɵ0 = filter;
export var SingleDropdownSelectFilter = {
    name: 'singleDropdownSelect',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-single-dropdown-select.filter.js.map